import { render, staticRenderFns } from "./DicItem.vue?vue&type=template&id=652e27de"
import script from "./DicItem.vue?vue&type=script&lang=js"
export * from "./DicItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports